import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import CustomerListView from 'src/views/customer/CustomerListView';
import DriverListView from 'src/views/customer/DriverListView';
import DashboardView from 'src/views/reports/DashboardView';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import AdminCreateView from 'src/views/admin/AdminCreateView';
import RegisterView from 'src/views/auth/RegisterView';
import SettingsView from 'src/views/settings/SettingsView';
import IsLoggedIn from './layouts/AuthLayout/IsLoggedIn';
import IsLoggedOut from './layouts/AuthLayout/IsLoggedOut';
import AdminListView from './views/admin/AdminListView';
import CustomerView from './views/customer/CustomerView';
import NewMessage from './views/message/NewMessage';
import BroadcastView from './views/broadcast/BroadcastView';
import BroadcastHistory from './views/broadcast/BroadcastHistory';
import SupportInboxView from './views/support/SupportInboxView';
import SupportTicketDetailView from './views/support/SupportTicketDetailView';
import AdminView from './views/admin/AdminView';
import ActivityLog from './views/ActivityLog';
import TripRoutes from './views/trip';
import RefundRequestRoutes from './views/refund';
import Policy from './Policy';
import TermsAndCondition from './TermsAndCondition';
import AdminProfile from './views/AdminProfile';
import BookingsList from './views/BookingsList';
import CustomerBookings from './views/customer/CustomerBookings';
import CustomerTrips from './views/customer/CustomerTrips';
import CustomerWallet from './views/customer/CustomerWallet';
import WalletWithdrawals from './views/wallet/WalletWithdrawals';
import WalletTransactions from './views/wallet/WalletTransactions';
import VerificationReviews from './views/VerificationReviews';
import ForgotView from './views/auth/ForgotView';
import ResetView from './views/auth/ResetView';
import storage from './storage';

// Same role source as NavBar (redux user is seeded from storage); API 403s non-super admins.
// eslint-disable-next-line react/prop-types
export const SuperOnly = ({ children }) =>
  storage.getUser()?.role === 'super' ? (
    children
  ) : (
    <Navigate replace to="/app/dashboard" />
  );

const routes = [
  {
    path: 'app',
    element: <IsLoggedOut component={DashboardLayout} />,
    children: [
      { path: 'customers', element: <CustomerListView /> },
      { path: 'drivers', element: <DriverListView /> },
      { path: 'customers/:id', element: <CustomerView /> },
      { path: 'customers/bookings/:id', element: <CustomerBookings /> },
      { path: 'customers/trips/:id', element: <CustomerTrips /> },
      { path: 'customers/wallet/:id', element: <CustomerWallet /> },
      { path: 'wallet/withdrawals', element: <WalletWithdrawals /> },
      { path: 'wallet/transactions', element: <WalletTransactions /> },
      { path: 'admins', element: <SuperOnly><AdminListView /></SuperOnly> },
      { path: 'admins/new', element: <SuperOnly><AdminCreateView /></SuperOnly> },
      { path: 'admins/:id', element: <SuperOnly><AdminView /></SuperOnly> },
      { path: 'profile', element: <AdminProfile /> },
      { path: 'bookings', element: <BookingsList /> },
      { path: 'dashboard', element: <DashboardView /> },
      { path: 'settings', element: <SuperOnly><SettingsView /></SuperOnly> },
      { path: 'message/new', element: <NewMessage /> },
      { path: 'broadcast/new', element: <SuperOnly><BroadcastView /></SuperOnly> },
      { path: 'broadcast/history', element: <SuperOnly><BroadcastHistory /></SuperOnly> },
      { path: 'support/tickets', element: <SupportInboxView /> },
      { path: 'support/tickets/:id', element: <SupportTicketDetailView /> },
      { path: 'verification-reviews', element: <VerificationReviews /> },
      { path: 'activity-log', element: <ActivityLog /> },
      ...TripRoutes,
      ...RefundRequestRoutes,
      { path: '*', element: <Navigate replace to="/404" /> }
    ]
  },
  { path: 'policy', element: <Policy /> },
  { path: 'terms-and-condition', element: <TermsAndCondition /> },
  {
    path: '/',
    element: <IsLoggedIn component={MainLayout} />,
    children: [
      { path: 'login', element: <LoginView /> },
      { path: 'forgot', element: <ForgotView /> },
      { path: 'reset/:id', element: <ResetView /> },
      { path: 'register', element: <RegisterView /> },
      { path: '/', element: <Navigate replace to="/app/dashboard" /> },
      { path: '*', element: <Navigate replace to="/404" /> }
    ]
  },

  {
    path: '404',
    element: <NotFoundView />
  }
];

export default routes;
